<template>
  <div>
    <v-form v-model="formValid">
      <v-container fluid class="pa-2" v-if="sessionActive">
        <v-row dense>

          <v-col cols="6">
            <v-container fluid class="pa-2">

              <v-row dense>

                <v-col cols="12">
                  <v-text-field
                      name="name"
                      label="Name"
                      v-model="form.data.name"
                      :error-messages="form.getError('name')"
                      :rules="nameRules"
                  ></v-text-field>

                </v-col>

                <v-col cols="12">

                  <v-text-field
                      name="email"
                      label="Email"
                      v-model="form.data.email"
                      :error-messages="form.getError('email')"
                      :rules="emailValidationRules"
                  ></v-text-field>

                </v-col>

                <!-- TODO User CellPhoneField component -->
                <v-col cols="4">
                  <v-text-field
                      name="Country Code"
                      label="Country Code"
                      v-model="form.data.country_code"
                      :error-messages="form.getError('country_code')"
                  ></v-text-field>

                </v-col>

                  <v-col cols="8">
                      <v-text-field
                              name="Phone Number"
                              label="Phone Number"
                              v-model="form.data.phone"
                              :error-messages="form.getError('phone')"
                      ></v-text-field>

                  </v-col>

                <v-col cols="12">

                  <v-select
                      label="Timezone"
                      :items="timezones"
                      v-model="form.data.timezone"
                      required
                      :error-messages="form.getError('timezone')"
                  ></v-select>

                </v-col>

                <v-col cols="12" class="text-sm-left">
                  <v-btn color="primary" :loading="userSaving" :disabled="!formValid"
                         @click="submit()">Save
                  </v-btn>
                </v-col>

              </v-row>

            </v-container>
          </v-col>

          <!-- AVATAR -->
          <v-col offset="2" cols="4" class="pt-7">

            <v-avatar
                @mouseover="setElevation(10)"
                @mouseleave="setElevation(2)"
                size="200"
                :class="'avatar cursor-pointer ' + elevation"
                @click="uploadDialogOpen=true"
                :color="user.photo_url ? 'transparent' : 'grey darken-2'"
            >

              <img v-if="user.photo_url" :src="user.photo_url">
              <div v-if="!user.photo_url" class="block title">
                <v-icon size="50">mdi-upload</v-icon>
                <div class="subtitle-2">UPLOAD PICTURE</div>
              </div>

            </v-avatar>

          </v-col>

        </v-row>

      </v-container>
    </v-form>

    <image-uploader-dialog v-model="uploadDialogOpen"
                           @change="profilePictureChanged"
                           title="Upload profile picture"
                           :max-width="700"
                           :description="uploadDescription"
                           :width="500"
                           :height="500">
    </image-uploader-dialog>

  </div>
</template>

<script>

import Form from '../../../components/forms/Form';
import {emailValidationRules} from '../../../components/mixins/emailValidationRulesMixin';
import activeSessionChecker from '../../../components/mixins/activeSessionCheckerMixin';
import {timeDisplay} from '../../../components/mixins/timeDisplayMixin';
import ImageUploaderDialog from "../../../components/UI/ImageUploaderDialog";
import Json from 'vue-json-pretty';

export default {
  components: {ImageUploaderDialog},
  mixins: [emailValidationRules, activeSessionChecker, timeDisplay],

  component: {
    ImageUploaderDialog,
    Json
  },

  props: {
    user: {
      type: Object,
      required: true
    },
    timezones: {
      type: Array,
      required: true
    },
    errorMessages: {
      type: Array,
      required: false,
      default: () => {
        return [];
      }
    },
    avatarSaving: {
      type: Boolean,
      required: false,
      default: false
    },
    userSaving: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      elevation: 'elevation-2',
      uploadDialogOpen: false,
      uploadDescription: "Upload your profile picture",
      formValid: false,
      nameRules: [
        v => !!v || 'Name is required',
        v => v.length > 5 || 'Name must be 5 characters or more'
      ],
      form: new Form({
        name: '',
        email: '',
        phone: '',
        country_code: ''
      })
    }
  },

  mounted() {

    this.form.data = Object.assign({}, this.user);
    this.form.setErrors(this.errorMessages);
  },

  methods: {

    setElevation(elevation) {
      this.elevation = 'elevation-' + elevation;
    },

    /**
     * File selected handler
     * @param event
     */
    fileSelectedHandler(event) {
      let file = event.target.files[0];

      this.validateExtension(file);

      const data = new FormData();

      data.append('id', this.user.id);
      data.append('photo', this.$refs.photo.files[0]);

      this.$emit('avatar-updated', data);
    },

    /**
     * Validate extension
     * @param file
     */

    validateExtension(file) {
      const extension = file.name.split('.').pop();

      if (extension === 'jpg' || extension === 'png') {
        this.file = file;
        this.e1 = 2;
        return;

      }

      Bus.$emit("flash-message", {
        type: 'error',
        message: 'Only jpg and png files are mappingsDone!'
      });
    },

    submit() {
      this.$emit('profile-updated', this.form.data);
    },

    profilePictureChanged(data) {

      this.uploadDialogOpen = false;
      this.$emit('avatar-updated', data);
    },
  }
}
</script>

<style scoped>

.avatar {
  position: relative;
}

</style>
